import { useBreakpoint } from '@vivino/js-react-common-ui';
import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { track } from 'vivino-js/analytics';
import Card from 'vivino-ui/atoms/Card';
import TasteNoteIcon, { OPTIONS as iconOptions } from 'vivino-ui/icons/TasteNote';
import TasteNoteIcon72 from 'vivino-ui/icons/TasteNote/72';

import { MAX_CHARS, NUMBER_OF_WORDS } from '../TasteNotes';
import TasteReviews from '../TasteReviews';
import styles from './tasteNote.scss';

const TRANSLATIONS_PATH = 'components.shared.taste_notes';
const TRANSLATIONS = {
  mentions: `${TRANSLATIONS_PATH}.count_mentions_of_note`,
};

const TasteNote = ({ note, wineId, vintageYear }) => {
  const { t } = useI18N();
  const [showModal, setShowModal] = useState(false);
  const { isMobile } = useBreakpoint();
  let keywordsText = note.primary_keywords
    .slice(0, NUMBER_OF_WORDS)
    .map((keyword) => keyword.name)
    .join(', ');

  if (keywordsText.length > MAX_CHARS) {
    keywordsText = keywordsText.substring(0, MAX_CHARS) + '...';
  }

  const noteColor = iconOptions[note.group].fill;

  const onCardClick = () => {
    track({
      event: 'Taste characteristics - open flavour group lightbox',
      props: {
        noteGroup: note.group,
      },
    });
    setShowModal(true);
  };

  return (
    <>
      <TasteReviews
        show={showModal}
        onClose={() => setShowModal(false)}
        note={note}
        wineId={wineId}
        vintageYear={vintageYear}
      />
      <Card className={styles.tasteNote} onClick={onCardClick}>
        <div
          className={styles.iconContainer}
          style={!isMobile ? { backgroundColor: noteColor } : {}}
        >
          {isMobile && <TasteNoteIcon className={styles.icon} id={note.group} />}
          {!isMobile && <TasteNoteIcon72 id={note.group} />}
        </div>
        <div className={styles.textContainer}>
          <div className={styles.popularKeywords}>{keywordsText}</div>
          <div className={styles.mentions} data-testid="mentions">
            {t(TRANSLATIONS.mentions, {
              count: note.stats.mentions_count,
              note: (
                <span key="note" className={styles.flavorGroup} style={{ color: noteColor }}>
                  {t(`${TRANSLATIONS_PATH}.${note.group}`)}
                </span>
              ),
            })}
          </div>
        </div>
      </Card>
    </>
  );
};

TasteNote.propTypes = {
  note: PropTypes.object.isRequired,
  vintageYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  wineId: PropTypes.number.isRequired,
};

export default TasteNote;
